{
  "$id": "wealthlane://forms/role-publish/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "watch": "sourceRoleId",
      "clear": ["destinationCompanyId"],
      "condition": {
        "meta": "mode",
        "equals": "create"
      }
    }
  ],
  "observers": [
    {
      "id": "prefillPublishedDestinations",
      "watch": "sourceRoleId",
      "condition": {
        "allOf": [
          {
            "field": "sourceRoleId",
            "notEmpty": true
          },
          {
            "meta": "mode",
            "equals": "create"
          }
        ]
      },
      "lookup": {
        "actionId": "FETCH_PUBLISHED_COMPANY_IDS_BY_ROLE",
        "params": {
          "roleId": "sourceRoleId"
        }
      },
      "mapTo": {
        "destinationCompanyId": "destinationCompanyId"
      },
      "debounceMs": 0
    }
  ],
  "rules": []
}
